import type { HeroSlide } from "@/types/film";

export const heroSlides: HeroSlide[] = [
  {
    id: "h1",
    tag: "焦点预告",
    title: "蜜桃成熟时3D",
    subtitle: "一场关于成长、离别与重逢的光影旅程，以沉浸式3D画面重新诠释经典回忆。首支正式预告现已公开。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20sunlit%20peach%20orchard%20at%20golden%20hour%20with%20soft%20warm%20amber%20haze%2C%20dreamy%20artistic%20film%20poster%20aesthetic%2C%20gentle%20bokeh%2C%20elegant%20atmospheric%20mood%2C%20warm%20cinematic%20lighting%2C%20high%20detail&width=1920&height=1080&seq=peach-hero-01&orientation=landscape",
    link: "/detail/n1",
  },
  {
    id: "h2",
    tag: "主创访谈",
    title: "用3D重构一段旧时光",
    subtitle: "导演与摄影指导深度对谈：如何让观众真正走进那片蜜桃园，感受四季流转与人物心境的变化。",
    image:
      "https://readdy.ai/api/search-image?query=dramatic%20cinematic%20silhouette%20of%20an%20elegant%20figure%20backlit%20by%20warm%20orange%20sunset%20light%2C%20artistic%20film%20poster%20style%2C%20soft%20haze%20and%20glowing%20rim%20light%2C%20warm%20peach%20and%20amber%20palette%2C%20high%20detail&width=1920&height=1080&seq=peach-hero-02&orientation=landscape",
    link: "/detail/n2",
  },
  {
    id: "h3",
    tag: "幕后特辑",
    title: "蜜桃园里的四季光影",
    subtitle: "从春日的嫩芽到盛夏的果实，幕后特辑带你走近3D拍摄现场，见证每一帧画面背后的耐心与热爱。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20cinematic%20scene%20of%20floating%20peach%20blossoms%20over%20a%20calm%20water%20surface%20reflecting%20warm%20golden%20light%2C%20surreal%20dreamy%20film%20backdrop%2C%20soft%20warm%20color%20grade%2C%20artistic%20and%20atmospheric%2C%20high%20detail&width=1920&height=1080&seq=peach-hero-03&orientation=landscape",
    link: "/detail/n4",
  },
];